export default "__VITE_ASSET__CAX5S3p4__"